const firebaseConfig = {
    apiKey: "AIzaSyCSIOTQh9i5V-pnesgQo8vR7gHsZJbNsCc",
    authDomain: "tour-champ11.firebaseapp.com",
    projectId: "tour-champ11",
    storageBucket: "tour-champ11.appspot.com",
    messagingSenderId: "1086753713858",
    appId: "1:1086753713858:web:1b20fb7a3f2e328c39555b",
    measurementId: "G-4TBQSTBN4X"
};
export default firebaseConfig;